import { memo, useCallback } from "react";
import { ToolSpec } from "types/json-schemas/type_guards";
import { ResourceTier } from "types/ResourceTiers";
import { CellEditorComputeResourcesBase } from "./CellEditorComputeResourcesBase";
import { CellValue } from "@inscopix/ideas-hyperformula";

interface CellEditorComputeResourcesProps {
  toolVersionResources: ToolSpec["resources"];
  toolVersionCredits: number;
  value: CellValue;
  stopEditing: (cancel?: boolean) => void;
  onChangeFormula: (formula: string) => void;
}

export const CellEditorComputeResources = memo(
  function CellEditorComputeResources({
    stopEditing,
    toolVersionCredits,
    toolVersionResources,
    value,
    onChangeFormula,
  }: CellEditorComputeResourcesProps) {
    const handleSelectResourceTier = useCallback(
      (resourceTier: ResourceTier["id"] | null) => {
        if (resourceTier === null) {
          onChangeFormula("");
        } else {
          onChangeFormula(String(resourceTier));
        }
      },
      [onChangeFormula],
    );

    return (
      <CellEditorComputeResourcesBase
        toolVersionResources={toolVersionResources}
        toolVersionCredits={toolVersionCredits}
        value={value}
        onSelectResourceTier={handleSelectResourceTier}
        stopEditing={stopEditing}
      />
    );
  },
);
